module.exports = __webpack_public_path__ + "img/mobile/BetBar/logo@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar/logo@2x.png
// module id = 185
// module chunks = 0